import { BOMBtpDialogComponent } from "../bom-btp-dialog/bom-btp-dialog.component";
import { BOMService } from "../bom-service/bom.service";
import { DungChungService } from "app/views/pages/nfc/dung-chung/__services/dung-chung.service";
import {
	Component,
	OnInit,
	Input,
	ChangeDetectionStrategy,
	HostListener,
	ElementRef,
	ViewChild,
	ChangeDetectorRef,
	ViewRef,
	Output,
	EventEmitter,
} from "@angular/core";
import {
	Observable,
	fromEvent,
	of,
	BehaviorSubject,
	ReplaySubject,
} from "rxjs";
import { distinctUntilChanged, tap, debounceTime } from "rxjs/operators";
import { Moment } from "moment";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TokenStorage } from "app/core/auth/_services/token-storage.service";
import { LayoutUtilsService } from "app/core/_base/crud/utils/layout-utils.service";
import {
	RdBoM,
	RdBoMCt,
} from "../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import { MatDialog } from "@angular/material";
import { BOMCt, LoopGiaiDoan, __DEFAULT__DSP } from "../bom-model/bom.model";
import { Router } from "@angular/router";

@Component({
	selector: "kt-bom-step-four",
	templateUrl: "./bom-step-four.component.html",
	styleUrls: ["../bom.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BOMStepFourComponent implements OnInit {
	CONFIG: CommonConFig;
	public ListDSNguyenLieu: BOMCt[] = [];
	private HieuSuatGiaiDoan: any[] = [];
	private DongSanPham: any = __DEFAULT__DSP.AD_FD;
	public MainForm4: FormGroup;
	@Input() set MainFormData(value: any) {
		this.MainForm4 = value;
	}
	@Input() set DSNguyenLieu(value: any[]) {
		this.ListDSNguyenLieu = value;
		this.changeDetectView();
	}
	@Input() set HieuSuatCacGiaiDoan(value: any) {
		this.HieuSuatGiaiDoan = value["ListBTP"];
		this.DongSanPham = value["DongSanPham"];
		if (this.HieuSuatGiaiDoan && this.HieuSuatGiaiDoan.length > 0)
			this.addHieuSuatGiaiDoan();
	}

	@Input() set InputNPL(value) {
		if (value && value["Details"] && value["Details"].length > 0) {
			this.Id = value["Master"].BoM_ThuHoi;
			this.Code = value["Master"].BoM_ThuHoi_Number;
		}
	}

	Id: number;
	Code: string;

	@Output() OuputData = new EventEmitter<BOMCt[]>();
	TinhTrang = [
		{
			id: 1,
			name: "Đang soạn thảo",
			value: "BOM_DANGSOANTHAO",
		},
		{
			id: 2,
			name: "Chờ xem xét",
			value: "BOM_CHOXACNHAN",
		},
		{
			id: 3,
			name: "Từ chối",
			value: "BOM_TUCHOIXACNHAN",
		},
		{
			id: 4,
			name: "Chờ duyệt",
			value: "BOM_CHODUYET",
		},
		{
			id: 5,
			name: "Đang áp dụng",
			value: "BOM_DANGAPDUNG",
		},
		{
			id: 6,
			name: "Từ chối duyệt",
			value: "BOM_TUCHOIDUYET",
		},
		{
			id: 7,
			name: "Đã hủy",
			value: "BOM_DAHUY",
		},
		{
			id: 8,
			name: "Đã xóa",
			value: "BOM_DAXOA",
		},
		{
			id: 9,
			name: "Đã thay thế",
			value: "BOM_DATHAYTHE",
		},
	];

	displayedColumnsf = [];
	availableColumnsf = [
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "MANGUYENLIEU",
			displayName: "Mã nguyên liệu",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "TENNGUYENLIEU",
			displayName: "Tên nguyên liệu",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "HIEUSUATNLTRUOCTRON",
			displayName: "Hiệu suất NL trước trộn",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 6,
			name: "TYLEPHAMTRAMME",
			displayName: "Tỷ lệ trộn(%)/mẻ",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 11,
			name: "KhoiLuongNLCan",
			displayName: "Khối lượng nguyên liệu (kg) cần để sx 100 kg TP",
			alwaysChecked: false,
			isShow: true,
		},
	];

	selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);

	list_QTSX: any[] = [];
	QTSX_FilterCtrl: string = "";
	filtered_QTSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_ThanhPham: any[] = [];
	ThanhPham_FilterCtrl: string = "";
	filtered_ThanhPham: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_NL: any[] = [];
	NL_FilterCtrl: string = "";
	filtered_NL: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_BTP: any[] = [];
	BTP_FilterCtrl: string = "";
	filtered_BTP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	ListGiaiDoan: any[] = [];

	constructor(
		private MainFormFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private DungChungService: DungChungService,
		private el: ElementRef,
		private service: BOMService,
		public dialog: MatDialog,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.CONFIG = new CommonConFig();
		this.GetSoGiaiDoan();
		this.GetListThanhPham();
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	getItemNameClassByStatus(status: any): string {
		switch (status) {
			case "BOM_DANGSOANTHAO":
				return "Đang soạn thảo";
			case "BOM_CHOXACNHAN":
				return "Chờ xem xét";
			case "BOM_TUCHOIXACNHAN":
				return "Từ chối";
			case "BOM_CHODUYET":
				return "Chờ duyệt";
			case "BOM_DANGAPDUNG":
				return "Đang áp dụng";
			case "BOM_TUCHOIDUYET":
				return "Không duyệt";
			case "BOM_DAHUY":
				return "Đã hủy";
			case "BOM_DAXOA":
				return "Đã xóa";
			case "BOM_DATHAYTHE":
				return "Đã thay thế";
			default:
				return "";
		}
	}

	showColumnsInTablef() {
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			if (this.availableColumnsf[i].isShow == false) {
				this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			}
		}
	}
	applySelectedColumnsf() {
		let _selectedColumns = this.selectedColumnsf.selected;
		this.selectedColumnsf = new SelectionModel<any>(
			true,
			this.availableColumnsf
		);
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (
					this.availableColumnsf[i].name == _selectedColumns[j].name
				) {
					this.selectedColumnsf.toggle(this.availableColumnsf[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumnsf.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumnsf = _applySelectedColumns;
	}

	async createBillNumber() {
		var category_path = "BOM";
		var res = await this.DungChungService.getBillNumber(category_path)
			.toPromise()
			.then((r) => {
				return r;
			});
		if (res && res.status == 1) return res.data;
		else
			this.layoutUtilsService.showErorr(
				"Không thể lấy số phiếu tự động."
			);
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	addHieuSuatGiaiDoan() {
		let controls = this.MainForm4.controls;
		switch (this.DongSanPham) {
			case __DEFAULT__DSP.AD_FD:
			case __DEFAULT__DSP.VIEN: {
				this.ListDSNguyenLieu.forEach((x) => {
					var arr = [];
					this.ListGiaiDoan.forEach((a) => {
						var hs = this.HieuSuatGiaiDoan.find(
							(z) => z.IdGiaiDoan == a.QtsxGiaidoanId
						);
						if (hs != null) arr.push(hs.HieuSuat);
						else arr.push(null);
					});
					x.ListHieuSuat = arr;
				});
				this.ListDSNguyenLieu = this.calcLKhoiLuongCan(
					this.ListDSNguyenLieu
				);
				break;
			}
			case __DEFAULT__DSP.HON_HOP: {
				var listBTP = this.ListDSNguyenLieu.filter(
					(x) =>
						x.LaBTP != null ||
						(x.LaBTP == null && x.ThuocBTP == null)
				).map((x) => this.ListDSNguyenLieu.indexOf(x));
				listBTP.forEach((l) => {
					var row = this.ListDSNguyenLieu;
					var HSGDTP = this.HieuSuatGiaiDoan.filter(
						(x) =>
							x.ThuocBTP ==
							this.HieuSuatGiaiDoan[
								this.HieuSuatGiaiDoan.length - 1
							].IdBTP
					).map((x) => x.HieuSuat);
					var gdIds = this.ListGiaiDoan.map(x => x.QtsxGiaidoanId);
					var hsGdIds = Array.from({length: gdIds.length}, (v, i) => 0);
					for(var i = hsGdIds.length - 1; i >= 0; i--){
						if(HSGDTP.length == 0)
							break;
						let v = HSGDTP.length - 1;
						hsGdIds[i] = HSGDTP[v];
						HSGDTP.splice(v,1)
					}
					// row[l].ListHieuSuat = [0, 0].concat(HSGDTP);
					row[l].ListHieuSuat = hsGdIds;
					hsGdIds = Array.from({length: gdIds.length}, (v, i) => 0);
					var iF = l + 1;
					var iL =
						listBTP.indexOf(l) + 1 >= listBTP.length
							? this.ListDSNguyenLieu.length
							: listBTP[listBTP.indexOf(l) + 1];
					if (iF < iL) {
						for (var __i = iF; __i < iL; __i++) {
							row[__i].ListHieuSuat = [];
							var IdBTP = row[l].IdNL;
							var HSGDBTP = this.HieuSuatGiaiDoan.filter(
								(x) => x.ThuocBTP == IdBTP
							).map((x) => x.HieuSuat);
							var max = 2;
							for(var i = hsGdIds.length - 1; i >= 0; i--){
								if(HSGDBTP.length == 0) break;
								if(i < max)
								{
									let v = HSGDBTP.length - 1;
									hsGdIds[i] = HSGDBTP[v];
									HSGDBTP.splice(v,1)
								}
							}
							row[__i].ListHieuSuat = hsGdIds;
							//row[__i].ListHieuSuat = HSGDBTP.concat([0, 0]);
						}
					}
				});

				var klB = this.ListDSNguyenLieu.filter((x) => x.LaBTP != null);
				klB = this.calcLKhoiLuongCan(
					this.ListDSNguyenLieu.filter(
						(x) =>
							x.LaBTP != null ||
							(x.LaBTP == null && x.ThuocBTP == null)
					)
				);

				listBTP.forEach((l) => {
					var iF = l + 1;
					var iL =
						listBTP.indexOf(l) + 1 >= listBTP.length
							? this.ListDSNguyenLieu.length
							: listBTP[listBTP.indexOf(l) + 1];
					var klC = this.ListDSNguyenLieu.slice(iF, iL);
					klC = this.calcLKhoiLuongCan(
						klC,
						this.ListDSNguyenLieu[l].KhoiLuongCanSX100
					);
				});

				break;
			}
		}

		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		this.outputDaTa();
		this.changeDetect.detectChanges();
	}

	async GetSoGiaiDoan() {
		let res = await this.service.GetSoGiaiDoan().toPromise();
		if (res && res.status === 1) {
			this.ListGiaiDoan = res.data ? res.data : [];
			var columns = [];
			this.ListGiaiDoan.forEach((x) => {
				var rObj = {};
				rObj["stt"] =
					this.availableColumnsf.length - 1 + columns.length;
				rObj["name"] = "HSGD" + (this.ListGiaiDoan.indexOf(x) + 1);
				rObj["displayName"] = "Hiệu suất " + x["TenGiaiDoan"];
				rObj["alwaysChecked"] = false;
				rObj["isShow"] = true;
				columns.push(rObj);
			});
			columns.forEach((element) => {
				this.availableColumnsf.splice(
					this.availableColumnsf.length - 1,
					0,
					element
				);
			});
			this.selectedColumnsf = new SelectionModel<any>(
				true,
				this.availableColumnsf
			);
			this.showColumnsInTablef();
			this.applySelectedColumnsf();
			this.addHieuSuatGiaiDoan();
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	findIndexOf(item: any) {
		let controls = this.MainForm4.controls;
		if (!controls["CODETHANHPHAM"].value)
			return this.ListDSNguyenLieu.indexOf(item) + 1;
		if (this.DongSanPham == 3) {
			if (item.LaBTP != null || !item.ThuocBTP)
				return (
					this.ListDSNguyenLieu.filter(
						(x) => x.LaBTP != null || !x.ThuocBTP
					).indexOf(item) + 1
				);
			else return "";
		}
		return this.ListDSNguyenLieu.indexOf(item) + 1;
	}

	findDongSanPham(IdHH: number) {
		return this.list_ThanhPham.find((x) => x.Id == IdHH).DongSanPham;
	}

	async GetListThanhPham() {
		let res = await this.service.GetListThanhPham().toPromise();
		if (res && res.status === 1) {
			this.list_ThanhPham = res.data
				.filter((ts) => ts.IdLoaihh == 4)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	calcLKhoiLuongCan(List: BOMCt[], KhoiLuongCan: number = 100) {
		if (List.length > 0) {
			var NLC = List.find((x) => x.IsNLC);
			var NLC_HSTT = NLC ? NLC.HieuSuatNLTruocTron / 100 : 1;
			var NLC_TLTM = NLC ? NLC.TyLeTronMe / 100 : 1;
			var MultiPerForm = 1;
			List[0].ListHieuSuat.forEach(
				(x) => (MultiPerForm *= x && x > 0 ? x / 100 : 1)
			);
			var ParentMassNLC = (1 / MultiPerForm) * NLC_HSTT;
			if (NLC)
				NLC.KhoiLuongCanSX100 =
					(ParentMassNLC * KhoiLuongCan) / NLC_HSTT;
			List.filter((x) => !x.IsNLC).forEach((r) => {
				var ParentMassPL = 0;
				if (NLC_TLTM > 0)
					ParentMassPL =
						(ParentMassNLC * (r.TyLeTronMe / 100)) /
						(NLC_TLTM * (r.HieuSuatNLTruocTron / 100));
				r.KhoiLuongCanSX100 = ParentMassPL * KhoiLuongCan;
			});
		}
		return List;
	}

	getTongCong() {
		var sum = 0;
		switch (this.DongSanPham) {
			case __DEFAULT__DSP.AD_FD: {
				this.ListDSNguyenLieu.forEach(
					(x) => (sum += x.KhoiLuongCanSX100)
				);
				break;
			}
			case __DEFAULT__DSP.VIEN: {
				this.ListDSNguyenLieu.forEach(
					(x) => (sum += x.KhoiLuongCanSX100)
				);
				break;
			}
			case __DEFAULT__DSP.HON_HOP: {
				this.ListDSNguyenLieu.filter(
					(x) => x.LaBTP != null || !x.ThuocBTP
				).forEach((x) => (sum += x.KhoiLuongCanSX100));
				break;
			}
		}
		return sum ? sum : 0;
	}

	outputDaTa() {
		this.OuputData.next(this.ListDSNguyenLieu);
	}

	routerLinkDetail(id){
		this.router.navigate(["/cong-thuc-dinh-muc/chi-tiet/"+id, {}]);
	}
}
